import { render, staticRenderFns } from "./MList.vue?vue&type=template&id=70374638&scoped=true&"
import script from "./MList.vue?vue&type=script&lang=js&"
export * from "./MList.vue?vue&type=script&lang=js&"
import style0 from "./MList.vue?vue&type=style&index=0&id=70374638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70374638",
  null
  
)

export default component.exports